import { render, staticRenderFns } from "./busOrder4.vue?vue&type=template&id=11075bac&scoped=true&"
import script from "./busOrder4.vue?vue&type=script&lang=js&"
export * from "./busOrder4.vue?vue&type=script&lang=js&"
import style0 from "./busOrder4.vue?vue&type=style&index=0&id=11075bac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11075bac",
  null
  
)

export default component.exports